module.exports = __webpack_public_path__ + "static/media/multi-school-support.4b19e471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/guide/multi-school-support.svg
// module id = 582
// module chunks = 0